import { useEffect } from 'react';

const useSVGCoordinateTracker = (svgContainerRef, enabled = true) => {
  useEffect(() => {
    if (!enabled || !svgContainerRef?.current) return;

    const handleSVGClick = (event) => {
      const svgContainer = svgContainerRef.current;
      const svgElement = svgContainer.querySelector('svg');
      
      if (!svgElement) return;

      // Lấy bounding box của SVG
      const svgRect = svgElement.getBoundingClientRect();
      
      // Tính tọa độ relative với SVG
      const svgX = event.clientX - svgRect.left;
      const svgY = event.clientY - svgRect.top;
      
      // Lấy viewBox của SVG để tính tọa độ SVG coordinate system
      const viewBox = svgElement.getAttribute('viewBox');
      let svgCoordX = svgX;
      let svgCoordY = svgY;
      
      if (viewBox) {
        const [minX, minY, width, height] = viewBox.split(' ').map(Number);
        const scaleX = width / svgRect.width;
        const scaleY = height / svgRect.height;
        
        svgCoordX = (svgX * scaleX) + minX;
        svgCoordY = (svgY * scaleY) + minY;
      }

      // Log thông tin chi tiết ra console
      console.log('=== SVG MAP COORDINATE TRACKER ===');
      console.log(`Screen coordinates: x=${event.clientX}, y=${event.clientY}`);
      console.log(`SVG relative coordinates: x=${Math.round(svgX)}, y=${Math.round(svgY)}`);
      console.log(`SVG coordinate system: x=${Math.round(svgCoordX)}, y=${Math.round(svgCoordY)}`);
      console.log('SVG ViewBox:', viewBox);
      console.log('SVG Rect:', {
        left: svgRect.left,
        top: svgRect.top,
        width: svgRect.width,
        height: svgRect.height
      });
      console.log('Target element:', event.target);
      console.log('Element tag:', event.target.tagName);
      console.log('Element classes:', event.target.className);
      console.log('Element id:', event.target.id);
      console.log('Timestamp:', new Date().toISOString());
      console.log('===================================');

      // Hiển thị alert với tọa độ SVG (có thể tắt nếu không muốn)
      if (process.env.NODE_ENV === 'development') {
        const message = `SVG Map Clicked:\nSVG Coordinates: (${Math.round(svgCoordX)}, ${Math.round(svgCoordY)})\nRelative: (${Math.round(svgX)}, ${Math.round(svgY)})`;
        // Uncomment dòng dưới nếu muốn hiển thị alert
        // alert(message);
      }
    };

    const svgContainer = svgContainerRef.current;
    
    // Thêm event listener cho SVG container
    svgContainer.addEventListener('click', handleSVGClick, true);

    // Cleanup function
    return () => {
      svgContainer.removeEventListener('click', handleSVGClick, true);
    };
  }, [enabled, svgContainerRef]);
};

export default useSVGCoordinateTracker;